import { render, staticRenderFns } from "./RptCerrados.vue?vue&type=template&id=3e31c532&"
import script from "./RptCerrados.vue?vue&type=script&lang=js&"
export * from "./RptCerrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports